const getOrderLineHCPCSCodeDescription = ({ orderLine, value, index }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (index !== undefined) {
    const indexOrderLine = orderLine ? orderLine[index] : null;
    if (indexOrderLine) {
      const HCPCSCoOde = indexOrderLine['HCPC S Code']['HCPC S Code'] || indexOrderLine['HCPC S Code'];
      return `${HCPCSCoOde}, ${indexOrderLine.Description}`;
    }
    return null;
  }
  return orderLine
    ? orderLine.map((item) => {
      const HCPCSCoOde = item['HCPC S Code']['HCPC S Code'] || item['HCPC S Code'];
      return `${HCPCSCoOde}, ${item.Description}`;
    }).join(', ')
    : null;
};

export default getOrderLineHCPCSCodeDescription;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineHCPCSCodeDescription.js